"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.compareSemver = exports.minimumCssVersion = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var minimumCssVersion = {
  majorVersion: '1',
  minorVersion: '5',
  patchVersion: '26',
  hash: 'sha256-Qb4yawV6X8/mvy+ZuOBPza1etcotbx9SFAnjZ+rW2Qw='
}; // using state only to track css being loaded is not enough to support hot-loading
// after first onCssLoad isLoaded state will always be true even across unmount/mounts

exports.minimumCssVersion = minimumCssVersion;
var cssLoaded;

var compareSemver = function compareSemver(a, b) {
  var aValues = [a.majorVersion, a.minorVersion, a.patchVersion];
  var bValues = [b.majorVersion, b.minorVersion, b.patchVersion];

  for (var i = 0; i < 3; i++) {
    if (aValues[i] === bValues[i]) {
      continue; // eslint-disable-line no-continue
    }

    if (aValues[i] < bValues[i]) {
      return -1;
    }

    return 1;
  }

  return 0;
};

exports.compareSemver = compareSemver;

var CssLoader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(CssLoader, _Component);

  function CssLoader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, CssLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(CssLoader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isLoaded: cssLoaded !== undefined ? cssLoaded : false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCssLoaded", function () {
      cssLoaded = true;

      _this.setState({
        isLoaded: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateLink", function () {
      // updates our link with the new url
      var overrideVersion = _this.props.overrideVersion; // could use semVer, but this is a simple scenario and mcp css version number are simple

      var version = !overrideVersion || compareSemver(minimumCssVersion, overrideVersion) >= 0 ? minimumCssVersion : overrideVersion; // eslint-disable-next-line max-len

      var url = "https://static.ux.cimpress.io/mcp-ux-css/".concat(version.majorVersion, ".").concat(version.minorVersion, "/development/").concat(version.majorVersion, ".").concat(version.minorVersion, ".").concat(version.patchVersion, "/css/mcp-ux-css.min.css");
      Object.assign(_this.cssLinkElement, {
        href: url,
        onload: _this.onCssLoaded,
        onerror: _this.onCssLoaded,
        rel: 'stylesheet',
        charSet: 'utf-8',
        integrity: version.hash,
        crossOrigin: 'anonymous'
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(CssLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // create and add link tag to the document head.
      // this was originally done using react-helmet, but that only allowed inline scripts for onload/onerror
      this.cssLinkElement = document.createElement('link');
      document.head.appendChild(this.cssLinkElement);
      this.updateLink();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // update link with css only if the override changes.
      if (!(0, _lodash["default"])(prevProps.overrideVersion, this.props.overrideVersion)) {
        this.updateLink();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cssLinkElement.parentNode.removeChild(this.cssLinkElement);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.isLoaded ? this.props.children : null;
    }
  }]);
  return CssLoader;
}(_react.Component);

exports["default"] = CssLoader;
CssLoader.propTypes = {
  overrideVersion: _propTypes["default"].shape({
    majorVersion: _propTypes["default"].string.isRequired,
    minorVersion: _propTypes["default"].string.isRequired,
    patchVersion: _propTypes["default"].string.isRequired,
    hash: _propTypes["default"].string.isRequired
  }),
  children: _propTypes["default"].node
};